import {ResourceType} from '../widgets/property-filter-menu/models/types';
import {SectionItem} from 'common/components/items-menu/types';

export const COUNTRIES = {
  AD: `Andorra`,
  AE: `United Arab Emirates`,
  AF: `Afghanistan`,
  AG: `Antigua and Barbuda`,
  AI: `Anguilla`,
  AL: `Albania`,
  AM: `Armenia`,
  AO: `Angola`,
  AQ: `Antarctica`,
  AR: `Argentina`,
  AS: `American Samoa`,
  AT: `Austria`,
  AU: `Australia`,
  AW: `Aruba`,
  AX: `\u00c5land Islands`,
  AZ: `Azerbaijan`,
  BA: `Bosnia and Herzegovina`,
  BB: `Barbados`,
  BD: `Bangladesh`,
  BE: `Belgium`,
  BF: `Burkina Faso`,
  BG: `Bulgaria`,
  BH: `Bahrain`,
  BI: `Burundi`,
  BJ: `Benin`,
  BL: `Saint Barth\u00e9lemy`,
  BM: `Bermuda`,
  BN: `Brunei Darussalam`,
  BO: `Bolivia, Plurinational State of`,
  BQ: `Bonaire, Sint Eustatius and Saba`,
  BR: `Brazil`,
  BS: `Bahamas`,
  BT: `Bhutan`,
  BV: `Bouvet Island`,
  BW: `Botswana`,
  BY: `Belarus`,
  BZ: `Belize`,
  CA: `Canada`,
  CC: `Cocos (Keeling) Islands`,
  CD: `Congo, the Democratic Republic of the`,
  CF: `Central African Republic`,
  CG: `Congo`,
  CH: `Switzerland`,
  CI: `C\u00f4te d'Ivoire`,
  CK: `Cook Islands`,
  CL: `Chile`,
  CM: `Cameroon`,
  CN: `China`,
  CO: `Colombia`,
  CR: `Costa Rica`,
  CU: `Cuba`,
  CV: `Cape Verde`,
  CW: `Cura\u00e7ao`,
  CX: `Christmas Island`,
  CY: `Cyprus`,
  CZ: `Czech Republic`,
  DE: `Germany`,
  DJ: `Djibouti`,
  DK: `Denmark`,
  DM: `Dominica`,
  DO: `Dominican Republic`,
  DZ: `Algeria`,
  EC: `Ecuador`,
  EE: `Estonia`,
  EG: `Egypt`,
  EH: `Western Sahara`,
  ER: `Eritrea`,
  ES: `Spain`,
  ET: `Ethiopia`,
  FI: `Finland`,
  FJ: `Fiji`,
  FK: `Falkland Islands (Malvinas)`,
  FM: `Micronesia, Federated States of`,
  FO: `Faroe Islands`,
  FR: `France`,
  GA: `Gabon`,
  GB: `United Kingdom`,
  GD: `Grenada`,
  GE: `Georgia`,
  GF: `French Guiana`,
  GG: `Guernsey`,
  GH: `Ghana`,
  GI: `Gibraltar`,
  GL: `Greenland`,
  GM: `Gambia`,
  GN: `Guinea`,
  GP: `Guadeloupe`,
  GQ: `Equatorial Guinea`,
  GR: `Greece`,
  GS: `South Georgia and the South Sandwich Islands`,
  GT: `Guatemala`,
  GU: `Guam`,
  GW: `Guinea-Bissau`,
  GY: `Guyana`,
  HK: `Hong Kong`,
  HM: `Heard Island and McDonald Islands`,
  HN: `Honduras`,
  HR: `Croatia`,
  HT: `Haiti`,
  HU: `Hungary`,
  ID: `Indonesia`,
  IE: `Ireland`,
  IL: `Israel`,
  IM: `Isle of Man`,
  IN: `India`,
  IO: `British Indian Ocean Territory`,
  IQ: `Iraq`,
  IR: `Iran, Islamic Republic of`,
  IS: `Iceland`,
  IT: `Italy`,
  JE: `Jersey`,
  JM: `Jamaica`,
  JO: `Jordan`,
  JP: `Japan`,
  KE: `Kenya`,
  KG: `Kyrgyzstan`,
  KH: `Cambodia`,
  KI: `Kiribati`,
  KM: `Comoros`,
  KN: `Saint Kitts and Nevis`,
  KP: `Korea, Democratic People's Republic of`,
  KR: `Korea, Republic of`,
  KW: `Kuwait`,
  KY: `Cayman Islands`,
  KZ: `Kazakhstan`,
  LA: `Lao People's Democratic Republic`,
  LB: `Lebanon`,
  LC: `Saint Lucia`,
  LI: `Liechtenstein`,
  LK: `Sri Lanka`,
  LR: `Liberia`,
  LS: `Lesotho`,
  LT: `Lithuania`,
  LU: `Luxembourg`,
  LV: `Latvia`,
  LY: `Libya`,
  MA: `Morocco`,
  MC: `Monaco`,
  MD: `Moldova, Republic of`,
  ME: `Montenegro`,
  MF: `Saint Martin (French part)`,
  MG: `Madagascar`,
  MH: `Marshall Islands`,
  MK: `Macedonia, the Former Yugoslav Republic of`,
  ML: `Mali`,
  MM: `Myanmar`,
  MN: `Mongolia`,
  MO: `Macao`,
  MP: `Northern Mariana Islands`,
  MQ: `Martinique`,
  MR: `Mauritania`,
  MS: `Montserrat`,
  MT: `Malta`,
  MU: `Mauritius`,
  MV: `Maldives`,
  MW: `Malawi`,
  MX: `Mexico`,
  MY: `Malaysia`,
  MZ: `Mozambique`,
  NA: `Namibia`,
  NC: `New Caledonia`,
  NE: `Niger`,
  NF: `Norfolk Island`,
  NG: `Nigeria`,
  NI: `Nicaragua`,
  NL: `Netherlands`,
  NO: `Norway`,
  NP: `Nepal`,
  NR: `Nauru`,
  NU: `Niue`,
  NZ: `New Zealand`,
  OM: `Oman`,
  PA: `Panama`,
  PE: `Peru`,
  PF: `French Polynesia`,
  PG: `Papua New Guinea`,
  PH: `Philippines`,
  PK: `Pakistan`,
  PL: `Poland`,
  PM: `Saint Pierre and Miquelon`,
  PN: `Pitcairn`,
  PR: `Puerto Rico`,
  PS: `Palestine, State of`,
  PT: `Portugal`,
  PW: `Palau`,
  PY: `Paraguay`,
  QA: `Qatar`,
  RE: `R\u00e9union`,
  RO: `Romania`,
  RS: `Serbia`,
  RU: `Russian Federation`,
  RW: `Rwanda`,
  SA: `Saudi Arabia`,
  SB: `Solomon Islands`,
  SC: `Seychelles`,
  SD: `Sudan`,
  SE: `Sweden`,
  SG: `Singapore`,
  SH: `Saint Helena, Ascension and Tristan da Cunha`,
  SI: `Slovenia`,
  SJ: `Svalbard and Jan Mayen`,
  SK: `Slovakia`,
  SL: `Sierra Leone`,
  SM: `San Marino`,
  SN: `Senegal`,
  SO: `Somalia`,
  SR: `Suriname`,
  SS: `South Sudan`,
  ST: `Sao Tome and Principe`,
  SV: `El Salvador`,
  SX: `Sint Maarten (Dutch part)`,
  SY: `Syrian Arab Republic`,
  SZ: `Swaziland`,
  TC: `Turks and Caicos Islands`,
  TD: `Chad`,
  TF: `French Southern Territories`,
  TG: `Togo`,
  TH: `Thailand`,
  TJ: `Tajikistan`,
  TK: `Tokelau`,
  TL: `Timor-Leste`,
  TM: `Turkmenistan`,
  TN: `Tunisia`,
  TO: `Tonga`,
  TR: `Turkey`,
  TT: `Trinidad and Tobago`,
  TV: `Tuvalu`,
  TW: `Taiwan, Province of China`,
  TZ: `Tanzania, United Republic of`,
  UA: `Ukraine`,
  UG: `Uganda`,
  UM: `United States Minor Outlying Islands`,
  US: `United States`,
  UY: `Uruguay`,
  UZ: `Uzbekistan`,
  VA: `Holy See (Vatican City State)`,
  VC: `Saint Vincent and the Grenadines`,
  VE: `Venezuela, Bolivarian Republic of`,
  VG: `Virgin Islands, British`,
  VI: `Virgin Islands, U.S.`,
  VN: `Vietnam`,
  VU: `Vanuatu`,
  WF: `Wallis and Futuna`,
  WS: `Samoa`,
  YE: `Yemen`,
  YT: `Mayotte`,
  ZA: `South Africa`,
  ZM: `Zambia`,
  ZW: `Zimbabwe`,
};

export enum ChartType {
  Bar = `bar`,
  Line = `line`,
  Metric = `metric`,
  Pie = `pie`,
  StackedBar = `bar-stacked`,
  StackedLine = `stacked-line`,
  Sankey = `sankey`,
  Table = `table`,
  FunnelSteps = `funnel-steps`,
  FunnelTrend = `funnel-trend`,
  FunnelMedianTTC = `funnel-median-ttc`,
  RetentionBar = `bar-retention`,
  Frequency = `frequency`,
  TopPaths = `top-paths`, // alias for Sankey
  Flows = `flows`, // alias for Sankey
  FlowsTopPaths = `paths`,
}

export const ChartTypeSelection: {[key in ChartType]: SectionItem} = {
  [ChartType.Bar]: {
    icon: `bar`,
    label: `Bar`,
    value: ChartType.Bar,
  },
  [ChartType.Line]: {
    icon: `line`,
    label: `Line`,
    value: ChartType.Line,
  },
  [ChartType.Metric]: {
    icon: `single-metric`,
    label: `Metric`,
    value: ChartType.Metric,
  },
  [ChartType.Pie]: {
    icon: `pie`,
    label: `Pie`,
    value: ChartType.Pie,
  },
  [ChartType.StackedBar]: {
    icon: `bar-stacked`,
    label: `Stacked Bar`,
    value: ChartType.StackedBar,
  },
  [ChartType.StackedLine]: {
    icon: `stacked-line`,
    label: `Stacked Line`,
    value: ChartType.StackedLine,
  },
  [ChartType.Sankey]: {
    icon: `top-paths`,
    label: `Top Paths`,
    value: ChartType.Sankey,
  },
  [ChartType.Table]: {
    icon: `table`,
    label: `Table`,
    value: ChartType.Table,
  },
  [ChartType.FunnelSteps]: {
    icon: `funnel-steps`,
    label: `Funnel Steps`,
    value: ChartType.FunnelSteps,
  },
  [ChartType.FunnelTrend]: {
    icon: `line`,
    label: `Funnel Trends`,
    value: ChartType.FunnelTrend,
  },
  [ChartType.FunnelMedianTTC]: {
    icon: `bar-stacked`,
    label: `Time to Convert`,
    value: ChartType.FunnelMedianTTC,
  },
  [ChartType.RetentionBar]: {
    icon: `bar`,
    label: `Bar`,
    value: ChartType.RetentionBar,
  },
  [ChartType.Frequency]: {
    icon: `bar`,
    label: `Frequency`,
    value: ChartType.Frequency,
  },
  [ChartType.TopPaths]: {
    icon: `top-paths`,
    label: `Top Paths`,
    value: ChartType.Sankey, // Alias
  },
  [ChartType.FlowsTopPaths]: {
    icon: `funnel-steps`,
    label: `Top Paths`,
    value: ChartType.FlowsTopPaths,
  },
  [ChartType.Flows]: {
    icon: `top-paths`,
    label: `User Flows`,
    value: ChartType.Sankey, // Alias
  },
};

export enum ValueRepresentationType {
  Absolute = `absolute`,
  Relative = `relative`,
}

export const ValueRepresentationTypeSelection: {[key in ValueRepresentationType]: SectionItem} = {
  [ValueRepresentationType.Absolute]: {
    icon: `value-absolute`,
    label: `Absolute`,
    value: ValueRepresentationType.Absolute,
  },
  [ValueRepresentationType.Relative]: {
    icon: `value-relative`,
    label: `Relative`,
    value: ValueRepresentationType.Relative,
  },
};

export const SESSION_START_EVENT_NAME = `$session_start`;
export const SESSION_END_EVENT_NAME = `$session_end`;
export const SESSION_EVENT_NAMES = Object.freeze({
  start: SESSION_START_EVENT_NAME,
  end: SESSION_END_EVENT_NAME,
});
export const SESSION_EVENTS = Object.freeze({
  [SESSION_START_EVENT_NAME]: {session_event: `start`},
  [SESSION_END_EVENT_NAME]: {session_event: `end`},
});

export const SPECIAL_EVENTS = {
  ALL_EVENTS: `$all_events`,
  TOP_EVENTS: `$top_events`,
  ANY_EVENT: `$mp_anything_event`,
  SESSION_START: SESSION_START_EVENT_NAME,
  SESSION_END: SESSION_END_EVENT_NAME,
};

export const SPECIAL_CONTROLS = {
  CREATE_INLINE_COHORT: {
    isControlItem: true,
    type: null,
    propertyDefaultType: null,
    icon: `compose`,
    label: `Create cohort...`,
    resourceType: ResourceType.Cohort,
    value: `create`,
  },
  CREATE_CUSTOM_EVENT_FORMULA: {
    icon: `compose`,
    isControlItem: true,
    type: null,
    propertyDefaultType: null,
    label: `Apply a Formula...`,
    resourceType: ResourceType.Event,
    tooltipData: {
      header: `Apply a Formula`,
      description: `Evaluate an excel-like formula using one or more property values. Common use-cases include: merging property values, comparing property values, complex and/or logic, customizing breakdown ranges, and much more.`,
    },
  },
  CREATE_CUSTOM_PEOPLE_FORMULA: {
    icon: `compose`,
    isControlItem: true,
    type: null,
    propertyDefaultType: null,
    label: `Apply a formula...`,
    resourceType: ResourceType.User,
    tooltipData: {
      header: `Apply a formula`,
      description: `Evaluate an excel-like formula using one or more property values. Common use-cases include: merging property values, comparing property values, complex and/or logic, customizing breakdown ranges, and much more.`,
    },
  },
};

/* eslint-disable camelcase */
export const EVENTS = {
  [SPECIAL_EVENTS.ALL_EVENTS]: `All Events`,
  [SPECIAL_EVENTS.TOP_EVENTS]: `Your Top Events`,
  $ae_crashed: `App Crashed`,
  $ae_first_open: `First App Open`,
  $ae_iap: `In-App Purchase`,
  $ae_notif_opened: `Push Notification Opened`,
  $ae_session: `App Session`,
  $ae_updated: `App Updated`,
  $campaign_bounced: `Message Bounced`,
  $campaign_delivery: `Message Sent`,
  $campaign_marked_spam: `Message Marked Spam`,
  $campaign_link_click: `Message Link Clicked`,
  $campaign_open: `Message Opened`,
  $campaign_received: `Message Received`,
  $create_alias: `Create Alias`,
  $experiment_started: `Experiment Started`,
  $identify: `Identify`,
  $journey_entered: `Campaign Entered`,
  $message_suppressed: `Message Suppressed`,
  $session_end: `Session End`,
  $session_start: `Session Start`,
  $show_survey: `Show Survey`,
  $signup: `Signup`,
};
/* eslint-enable camelcase */

/* eslint-disable camelcase */
export const PROPERTIES = {
  $ae_crashed_reason: `Crash Reason`,
  $ae_first_app_open_date: `First App Open Date`,
  $ae_iap_name: `Product Name`,
  $ae_iap_price: `Product Price`,
  $ae_iap_quantity: `Product Quantity`,
  $ae_notif_message: `Message`,
  $ae_session_length: `Session Length`,
  $ae_total_app_session_length: `Total App Session Length`,
  $ae_total_app_sessions: `Total App Sessions`,
  $ae_updated_version: `Version Updated`,
  $answer_count: `Answer Count`,
  $app_build_number: `$app_build_number`,
  $app_release: `App Release`,
  $app_version: `App Version`,
  $app_version_string: `$app_version_string`,
  $bluetooth_enabled: `Bluetooth Enabled`,
  $bluetooth_version: `Bluetooth Version`,
  $brand: `Brand`,
  $browser: `Browser`,
  $browser_version: `Browser Version`,
  $campaigns: `Messages Sent`,
  $carrier: `Carrier`,
  $city: `City`,
  $current_url: `Current URL`,
  $experiments: `Experiments`,
  $device: `Device`,
  $duration: `Duration`,
  $duration_s: `Session Duration (Seconds)`,
  $event_count: `Session Event Count`,
  $from_binding: `From Binding`,
  $google_play_services: `Google Play Services`,
  $has_nfc: `Has NFC`,
  $has_telephone: `Has Telephone`,
  $import: `Import`,
  $initial_referrer: `Initial Referrer`,
  $initial_referring_domain: `Initial Referring Domain`,
  $ios_ifa: `iOS IFA`,
  $journey_controls: `Campaign Controls`,
  $journey_id: `Campaign`,
  $journeys: `Campaigns`,
  $lib_version: `Library Version`,
  $manufacturer: `Manufacturer`,
  $model: `Model`,
  $os: `Operating System`,
  $os_version: `OS Version`,
  $radio: `Radio`,
  $referrer: `Referrer`,
  $referring_domain: `Referring Domain`,
  $region: `Region`,
  $screen_dpi: `Screen DPI`,
  $screen_height: `Screen Height`,
  $screen_width: `Screen Width`,
  $search_engine: `Search Engine`,
  $survey_shown: `Survey Shown`,
  $watch_model: `Watch Model`,
  $wifi: `Wifi`,
  campaign_id: `Message`,
  collection_id: `Collection ID`,
  message_id: `Variant`,
  message_subtype: `Message Subtype`,
  message_type: `Message Type`,
  mp_country_code: `Country`,
  mp_device_model: `Device Model`,
  mp_keyword: `Search Keyword`,
  mp_lib: `Mixpanel Library`,
  survey_id: `Survey ID`,
  utm_campaign: `UTM Campaign`,
  utm_content: `UTM Content`,
  utm_medium: `UTM Medium`,
  utm_source: `UTM Source`,
  utm_term: `UTM Term`,

  // the following are no longer used but
  // should be included for historical reasons
  mp_browser: `Browser`,
  mp_page: `Page View`,
  mp_platform: `Platform`,
  mp_referrer: `Referrer`,
};
/* eslint-enable camelcase */

export const NOT_APPLICABLE_PROPERTY_VALUE = `$not_applicable`;

export const DATASET_PROPERTY_NAME = `$dataset`;

export enum ProjectType {
  Normal = 1,
  Rollup = 3,
}

export const DATASET_MIXPANEL = `$mixpanel`;
export const DATASET_SALESFORCE = `salesforce`;
export const DATASET_ZENDESK = `zendesk`;

export const DATASET_SALESFORCE_CONTACTS = `contacts`;
export const DATASET_SALESFORCE_LEADS = `leads`;

export const PROPERTY_TYPES = {
  BOOLEAN: `boolean`,
  DATETIME: `datetime`,
  LIST: `list`,
  NUMBER: `number`,
  OBJECT: `object`,
  STRING: `string`,
  DIMENSION: `dimension`,
};

export const TYPECAST_PROPERTY_TYPES = {
  STRING: `string`,
  NUMBER: `number`,
  BOOLEAN: `boolean`,
  DATETIME: `datetime`,
  LIST: `list`,
};

export const NUMERIC_PROPERTY_TYPES = [PROPERTY_TYPES.BOOLEAN, PROPERTY_TYPES.DATETIME, PROPERTY_TYPES.NUMBER];

export const STRING_TYPECAST_PROPERTIES = [`message_id`, `campaign_id`, `$experiment_id`, `$variant_id`];

export enum MappedPropertyValues {
  Campaigns = `$campaigns`,
  CampaignId = `campaign_id`,
  Dataset = `$dataset`,
  ExperimentId = `$experiment_id`,
  MessageId = `message_id`,
  VariantId = `$variant_id`,
}

export enum PRIMATIVE_MATH_TYPES {
  TOTAL = `total`,
  UNIQUE = `unique`,
  SESSIONS = `sessions`,
  AVERAGE = `average`,
  MEDIAN = `median`,
  MIN = `min`,
  MAX = `max`,
}

export enum NUMERIC_MATH_TYPES {
  P90 = `p90`,
  P99 = `p99`,
}

export enum XAU_MATH_TYPES {
  DAU = `dau`,
  WAU = `wau`,
  MAU = `mau`,
}

export const EVENT_MATH_LABELS = {
  TOTAL: `Total`,
  UNIQUE: `Unique`,
  SESSIONS: `Sessions`,
  AVERAGE: `Average`,
  MEDIAN: `Median`,
  MIN: `Min`,
  MAX: `Max`,
  P90: `P90`,
  P99: `P99`,
  DAU: `DAU`,
  WAU: `WAU`,
  MAU: `MAU`,
};

export const PROPERTY_MATH_LABELS = {
  ...EVENT_MATH_LABELS,
  TOTAL: `Sum`,
};

export type MATH_TYPE = PRIMATIVE_MATH_TYPES | NUMERIC_MATH_TYPES | XAU_MATH_TYPES;

export const XAU_ONLY_MATH_TYPES = Object.values(XAU_MATH_TYPES);

export const ALL_MATH_TYPES = {
  ...PRIMATIVE_MATH_TYPES,
  ...NUMERIC_MATH_TYPES,
  ...XAU_MATH_TYPES,
};

export const SPECIAL_SERIES_NAMES = {
  $cohort: `Cohort`,
  $event: `Event`,
  $people: `People`,
};

export const FEATURE_GATES_UNLIMITED = 9223372036854776000; // python max int, aka featureGates.unlimited
export const MAX_DATA_HISTORY_DAYS_UPGRADE_LIMIT = 365 * 5; // maximum upgradeable historic data days

export const RESOURCE_LABELS = Object.freeze({
  USER: `User`,
  GROUP: `Group`,
  EVENT: `Event`,
});

export const MAIN_CLUSTER_NAME = `mixpanel-prod-1`;
export const EU_CLUSTER_NAME = `mixpanel-prod-eu`;
export const TRACKING_URL_BY_CLUSTER = {
  [MAIN_CLUSTER_NAME]: `https://api.mixpanel.com`,
  [EU_CLUSTER_NAME]: `https://api-eu.mixpanel.com`,
};

export const DISABLED_DUE_TO_SENSITIVE_DATA = [
  `Disabled due to sensitive data. Please contact your Project`,
  `owner/admin if you think you need access to this.`,
].join(`\n`);

export const ACCESS_SENSITIVE_ERROR_MESSAGE = [
  `You do not have access to this report because it contains data`,
  `that has been marked sensitive. Contact your Admin to request access.`,
].join(`\n`);
